import React from 'react'
import { DefaultButton, DialogFooter, PrimaryButton, TextField } from '@fluentui/react'
import { Controller, useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useReadingFormStyles } from './style'

const requiredMessage = "Це поле обов'язкове"

const twoZoneMeterReadingFormSchema = z.object({
  dayZoneConsumption: z.string({ required_error: requiredMessage }),
  nightZoneConsumption: z.string({ required_error: requiredMessage }),
})

export type TwoZoneMeterReadingFormState = z.infer<typeof twoZoneMeterReadingFormSchema>

interface TwoZoneMeterReadingFormProps {
  onCancel: () => void
  onSubmit: (formValues: TwoZoneMeterReadingFormState) => void
}

export const TwoZoneMeterReadingForm: React.FC<TwoZoneMeterReadingFormProps> = ({ onCancel, onSubmit }) => {
  const classes = useReadingFormStyles()
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<TwoZoneMeterReadingFormState>({
    resolver: zodResolver(twoZoneMeterReadingFormSchema),
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.formFields}>
        <Controller
          name="dayZoneConsumption"
          control={control}
          render={(props) => (
            <TextField
              {...props.field}
              errorMessage={errors?.[props.field?.name]?.message as string}
              label="День"
              placeholder="Введіть денні показання"
            />
          )}
        />
        <Controller
          name="nightZoneConsumption"
          control={control}
          render={(props) => (
            <TextField
              {...props.field}
              errorMessage={errors?.[props.field?.name]?.message as string}
              label="Ніч"
              placeholder="Введіть нічні показання"
            />
          )}
        />
      </div>
      <DialogFooter styles={{ actionsRight: { justifyContent: 'flex-start' } }}>
        <PrimaryButton width="100%" text="Зберегти показання" type="submit" />
        <DefaultButton width="100%" onClick={onCancel} type="reset" text="Скасувати передачу" />
      </DialogFooter>
    </form>
  )
}
